import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654b8006"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-5",
  style: {"max-height":"900px","overflow-y":"auto"}
}
const _hoisted_2 = { class: "row row-cols-2 g-5" }
const _hoisted_3 = { class: "row row-cols-2 g-5" }
const _hoisted_4 = { class: "row row-cols-2 g-5" }
const _hoisted_5 = { class: "row row-cols-2 g-5" }
const _hoisted_6 = { class: "row row-cols-2 g-5" }
const _hoisted_7 = { class: "row row-cols-2 g-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "d-flex gap-1" }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

import { ref, reactive, onMounted } from "vue";
import type { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventServices from "../../services/EventsServices";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import { AccessRoles, PointRoles } from "@/core/types/shop/ShopEventRoles";
import UploadImage from "../shop/UploadImage.vue";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEvent',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {


const isSubmitting = ref(false);
const showKeyError = ref(false);
const modalRef = ref(false);
const langOptions = ref<any>([]);
const contentList = ref({});
const uploadImageRef = ref<any>(null);
const uploadMobileImageRef = ref<any>(null);
const step = ref(0);
const pointItem = ref("all");
const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  name: [
    { required: true, message: "Please input item name", trigger: "blur" },
  ],
  title: [
    { required: true, message: "Please input item title", trigger: "blur" },
  ],
  key: [{ required: true, message: "Please input item key", trigger: "blur" }],
});

const accessRoles = AccessRoles;

const formData = ref<any>({
  name: "",
  accessRoles: ["Client", "Guest", "IB", "Sales"],
  accessSites: [],
  description: "",
  language: "en-us",
  instruction: {
    pointsRule: {
      all: "All",
      agent: "Agent",
      sales: "Sales",
      client: "Client",
    },
  },
  images: {},
});

const show = async () => {
  modalRef.value = true;
};

const hide = () => {
  modalRef.value = false;
  showKeyError.value = false;
  step.value = 0;
};

const successHide = () => {
  formData.value = {
    name: "",
    accessRoles: ["Client", "Guest", "IB", "Sales", "TenantAdmin"],
    accessSites: [],
    description: "",
    language: "en-us",
    instruction: {
      pointsRule: {
        all: "All",
        agent: "Agent",
        sales: "Sales",
        client: "Client",
      },
    },
    images: {},
  };
  hide();
};

const switchPointsContent = (lang: string) => {
  pointItem.value = lang;
};

const populateLangOptions = () => {
  const langKeys = Object.keys(contentList.value);
  langOptions.value = LanguageTypes.all.filter(
    (lang) => !langKeys.includes(lang.code)
  );
};

const processDefaultData = async () => {
  formData.value.name = formData.value.title;
  if (formData.value.key.includes(" ")) {
    formData.value.key = formData.value.key.replace(/\s/g, "-");
  }
  if (!formData.value.applyStartOn)
    formData.value.applyStartOn = new Date().toISOString();
  if (!formData.value.applyEndOn)
    formData.value.applyEndOn = new Date().toISOString();
  if (!formData.value.startOn)
    formData.value.startOn = new Date().toISOString();
  if (!formData.value.endOn) formData.value.endOn = new Date().toISOString();
};

const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid) => {
    isValid = valid;
  });
  if (!isValid) return;

  isSubmitting.value = true;
  try {
    await processDefaultData();
    await uploadMobileImageRef.value?.uploadImage().then(() => {
      if (uploadMobileImageRef.value?.imageUrls.length > 0) {
        formData.value.images["mobile"] =
          uploadMobileImageRef.value?.imageUrls[0];
      }
    });

    await uploadImageRef.value
      ?.uploadImage()
      .then(() => {
        if (uploadImageRef.value?.imageUrls.length > 0) {
          formData.value.images["desktop"] = uploadImageRef.value?.imageUrls[0];
        }
      })
      .then(() => {
        //
      });
    await EventServices.createEvent(formData.value).then(() => {
      MsgPrompt.success("Event created successfully");
      emits("submit");
      successHide();
    });
  } catch (error) {
    console.log(error);
    if (error.response.data == "__KEY_ALREADY_EXISTS__") {
      step.value = 0;
      showKeyError.value = true;
    }
    MsgPrompt.error(error);
  }
  isSubmitting.value = false;
};

const uploadImg = async (file: any) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await EventServices.uploadImage(formData);
  return res["url"];
};

const getModules = (index: number) => {
  return [
    {
      name: "imageUploader" + index,
      module: ImageUploader,
      options: {
        upload: (file) => {
          return uploadImg(file);
        },
      },
    },
    {
      name: "blotFormatter" + index,
      module: BlotFormatter,
    },
  ];
};
onMounted(() => {
  populateLangOptions();
});
__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: modalRef.value,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((modalRef).value = $event)),
    title: _ctx.$t('action.addEvent'),
    "before-close": hide,
    class: "w-1000px",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        (step.value == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_el_button, {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (modalRef.value = false)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (step.value++)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.next")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : (step.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_el_button, {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (step.value--)),
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.back")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (step.value++)),
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.next")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_el_button, {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (step.value--)),
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.back")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: submit,
                  loading: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_steps, {
          style: {"max-width":"800px"},
          active: step.value,
          "finish-status": "success",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_step, {
              title: _ctx.$t('fields.basicInfo')
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$t('fields.content')
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$t('fields.pointsRules')
            }, null, 8, ["title"])
          ]),
          _: 1
        }, 8, ["active"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: formData.value,
            rules: rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.eventTitle'),
                    prop: "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
                        disabled: isSubmitting.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: 
                  _ctx.$t('fields.eventKey') +
                  ' (Only English letter and number, no space)'
                ,
                    prop: "key"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.key,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.key) = $event)),
                        disabled: isSubmitting.value
                      }, null, 8, ["modelValue", "disabled"]),
                      (showKeyError.value)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "error",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Key already exists ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.accessRoles'),
                    prop: "accessRoles"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: formData.value.accessRoles,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.accessRoles) = $event)),
                        disabled: isSubmitting.value
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (role, index) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: index,
                              label: role.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(role.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.site'),
                    prop: "accessSites"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: formData.value.accessSites,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.accessSites) = $event)),
                        disabled: isSubmitting.value
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (role, index) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: index,
                              label: role.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(role.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.applyStartDate'),
                    props: "applyStartOn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.applyStartOn,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.applyStartOn) = $event)),
                        type: "datetime",
                        placeholder: "Apply Start Date",
                        disabled: isSubmitting.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.applyEndDate'),
                    props: "applyEndOn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.applyEndOn,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.applyEndOn) = $event)),
                        type: "datetime",
                        placeholder: "Apply End Date",
                        disabled: isSubmitting.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.eventStartDate'),
                    props: "startOn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.startOn,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.startOn) = $event)),
                        type: "datetime",
                        placeholder: "Event Start Date",
                        disabled: isSubmitting.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.eventEndDate'),
                    props: "endOn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.endOn,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.endOn) = $event)),
                        type: "datetime",
                        placeholder: "Event End Date",
                        disabled: isSubmitting.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('action.uploadDesktopImage'),
                    prop: "image"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UploadImage, {
                        ref_key: "uploadImageRef",
                        ref: uploadImageRef
                      }, null, 512)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('action.uploadMobileImage'),
                    prop: "image"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UploadImage, {
                        ref_key: "uploadMobileImageRef",
                        ref: uploadMobileImageRef
                      }, null, 512)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ], 512), [
                [_vShow, step.value == 0]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('fields.language'),
                    prop: "language"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.language,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.language) = $event)),
                        class: "w-200px",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.code,
                              label: item.code + '   (' + item.name + ')',
                              value: item.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.code + "   (" + item.name + ")"), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.content'),
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(QuillEditor), {
                        theme: "snow",
                        content: formData.value.description,
                        "onUpdate:content": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.description) = $event)),
                        modules: getModules(1),
                        contentType: "html",
                        toolbar: "full",
                        enable: !isSubmitting.value
                      }, null, 8, ["content", "modules", "enable"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('title.termsAndConditions'),
                  prop: "term"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(QuillEditor), {
                        theme: "snow",
                        content: formData.value.term,
                        "onUpdate:content": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.term) = $event)),
                        modules: getModules(2),
                        contentType: "html",
                        toolbar: "full",
                        enable: !isSubmitting.value
                      }, null, 8, ["content", "modules", "enable"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 512), [
                [_vShow, step.value == 1]
              ]),
              (step.value == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.pointsRules'),
                      prop: "pointRules"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: pointItem.value,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((pointItem).value = $event)),
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PointRoles), (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_radio_button, {
                                key: index,
                                label: item.value,
                                onClick: ($event: any) => (switchPointsContent(item.value))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", null, _toDisplayString(item.label), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.content'),
                      prop: "description"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(QuillEditor), {
                            theme: "snow",
                            content: formData.value.instruction.pointsRule[pointItem.value],
                            "onUpdate:content": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.instruction.pointsRule[pointItem.value]) = $event)),
                            modules: getModules(1),
                            contentType: "html",
                            toolbar: "full",
                            enable: !isSubmitting.value
                          }, null, 8, ["content", "modules", "enable"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})